export default "/images/Lancet.png?fb077fbe0370f28e6da4da24afac6aa1";